// extracted by mini-css-extract-plugin
module.exports = {"delivery-address":"OrderDetailsCoupons_delivery-address__1wcHZ"};